// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57e0fd12","538":"7502cfce","566":"0d787d16","614":"084c75c7","842":"d6998fed"}[chunkId] + ".chunk.js";
};